/*  */

//*componentes-utiles
//*datos

//*clases

//*componente
    export default function PaginaMenu2() {
    return (
        <div className="container container-Vista" >
        <h1>Página menu 2</h1>
        <br></br>
        </div>
    );
    }
